<script>
import Vue from 'vue'

import axios from 'axios'
import Multiselect from 'vue-multiselect'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
 import {
  required
} from 'vuelidate/lib/validators' 

/**
 * Editar tipo de documento.
 */
export default {
  components: { Layout, PageHeader, Multiselect  },
  page: {
    title: 'Tipo Documento',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {     
      title: 'Tipo Documento',
        requestComboMetaDatos :{
        perPage : 100,
        cuerrentPage :0,
        filter: ""
      },
      isLoadingCombo : false,
      listadoMetaDatos: [],
      form: {
        id : '',
        descripcion: '',
        metadatoSeleccionados :null        
      },
      items: [
        {
          text: 'REPODECAM',
          href: '/',
        },
        {
          text: 'Tipo Documento',
          href: '/tipoDocumento/index',
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
       isBusy: false,
       submitted: false,
    }
  },
  validations: {
    form: {
      descripcion: { required },
      claveTipoDocumento: { required }
      
    },
},
  computed:{
  
  },
  mounted(){
    this.loadMetaDatos();  
     this.loadTipoDocumento(this.$route.params.idTipoDocumento);   
  },
   methods:{
    loadTipoDocumento(id){
       axios
            .get(appConfig.recursosApi.tipoDocumento+ "/" + id )
            .then((response) => {
                this.form = response.data
            })
             .catch(()=>  {
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                this.$router.push('/500') ;
            });

    },
    loadMetaDatos(query=""){

        this.isLoadingCombo = true;
        this.requestComboMetaDatos.filter = query;
        axios
            .get(appConfig.recursosApi.metadato,{params: this.requestComboMetaDatos  })
            .then((response) => {

                this.listadoMetaDatos = response.data.result;
                
                this.isLoadingCombo = false;
                return this.data
            })
             .catch(()=>  {
              this.listadoMetaDatos = [];
               this.isLoadingCombo = false;
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                this.$router.push('/500') ;
                
            }); 
    },
    handleSubmit(e) {
      this.submitted = true
       
      this.isBusy = false;
      if(!this.$v.$invalid){

      this.isBusy = true;
        return axios
            .put(appConfig.recursosApi.tipoDocumento , this.form)
            .then((response) => {

                this.isBusy = false;
               this.$router.push('/tipoDocumento/index/true') ;
            }).catch(()=>  {

                this.isBusy = false;
               Vue.swal({
        type: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error al intentar guardar los datos.',
        confirmButtonClass: 'btn btn-confirm mt-2',
        
      })
            });

      }
      this.$v.$touch()
    },


   }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
 <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title m-t-0">Editar Tipo Documento</h4>
          <p
            class="text-muted font-14 m-b-20"
          >Ingrese la información del tipo de documento.</p>

          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="name">
                Tipo Documento
                <span class="text-danger">*</span>
              </label>
              <input
                id="descripcion"
                v-model="form.descripcion"
                name="descripcion"
                class="form-control"
                :class="{ 'is-invalid': submitted && $v.form.descripcion.$error }"
                type="text"
                placeholder=""
              />
              <div
                v-if="submitted && !$v.form.descripcion.required"
                class="invalid-feedback"
              >Debe ingresar el nombre del tipo de documento.</div>
            </div>

               <div class="form-group">
              <label for="name">
                Clave
                <span class="text-danger">*</span>
              </label>
              <input
                id="clave"
                v-model="form.claveTipoDocumento"
                name="descripcion"
                class="form-control"
                :class="{ 'is-invalid': submitted && $v.form.claveTipoDocumento.$error }"
                type="text"
                placeholder=""
              />
              <div
                v-if="submitted && !$v.form.claveTipoDocumento.required"
                class="invalid-feedback"
              >Debe ingresar el nombre la clave del tipo de documento.</div>
            </div>

            <div class="form-group">
              <label for="name">
                Metadatos 
              </label>
              <multiselect id="organismo" v-model="form.metadatoSeleccionados"  
                            label="descripcion" 
                            track-by="idMetadato" 
                            placeholder="Teclea el nombre del metadato" 
                            open-direction="bottom" 
                            deselect-label=" X "
                            select-label=" + "
                            selected-label=" Seleccionado"
                            :options="listadoMetaDatos" 
                            :multiple="true" 
                            :searchable="true" 
                            :loading="isLoadingCombo" 
                            :internal-search="false" 
                            :clear-on-select="false" 
                            :close-on-select="true" 
                            :options-limit="100" 
                            :limit="20" 
                            :max-height="500" 
                            :show-no-results="true" 
                            :hide-selected="false"
                            @search-change="loadMetaDatos" >
                            <span slot="noResult">No se encontraron resultados.</span>
                            <span slot="noOptions">No se encontraron metadatos.</span>
 
                            </multiselect>
              
            </div>
            
          
            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">   <b-spinner v-show="isBusy"  small></b-spinner>  Guardar</button>
              <router-link class="btn btn-secondary m-l-5 ml-1" to="/tipoDocumento/index"> Cancelar</router-link>
            </div>
          </form>
        </div>
        <!-- end card-box -->
      </div>
 </div>
  </Layout>
</template>